import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';

type SierraGatewayDeviceUpdateEndpointSpecification = ApiEndpointSpecification;
export const SierraGatewayDeviceUpdateEndpointSpecification: SierraGatewayDeviceUpdateEndpointSpecification = {
    url: '/api/sierradevice/update/gateway',
    method: HttpMethod.PUT,
    requestParamsSchemaName: 'SierraGatewayDeviceUpdateRequestParams',
    requestBodySchemaName: 'SierraGatewayDeviceUpdateRequestBody',
    okResponseSchemaName: 'SierraGatewayDeviceUpdateOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeSierraGatewayDeviceUpdate = Helpers.makeApiRequestFn<
    Types.SierraGatewayDeviceUpdateRequestParams,
    Types.SierraGatewayDeviceUpdateRequestBody,
    Types.SierraGatewayDeviceUpdateOkResponse
>(SierraGatewayDeviceUpdateEndpointSpecification);
